<div class="row">
  <div *ngIf="showThumbnails" class="col-3 col-md-2">
    <a *ngIf="linkType != linkTypes.None" [target]="(linkType == linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType == linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
       [routerLink]="[itemPageRoute]" class="dont-break-out" role="link" tabindex="-1">
    <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="true">
    </ds-thumbnail>
    </a>
    <span *ngIf="linkType == linkTypes.None" class="dont-break-out">
    <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="true">
    </ds-thumbnail>
    </span>
  </div>
  <div [ngClass]="showThumbnails ? 'col-9' : 'col-md-12'">
    <div class="d-flex">
      <ds-themed-badges *ngIf="showLabel" [object]="dso" [context]="context" [showAccessStatus]="true"></ds-themed-badges>
    </div>

    <ds-truncatable [id]="dso.id" *ngIf="object !== undefined && object !== null">
      <a *ngIf="linkType != linkTypes.None" [target]="(linkType == linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType == linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
         [routerLink]="[itemPageRoute]" class="lead item-list-title dont-break-out"
         [innerHTML]="dsoTitle" role="link" tabindex="0"></a>
      <span *ngIf="linkType == linkTypes.None" class="lead item-list-title dont-break-out"
            [innerHTML]="dsoTitle"></span>
      <span class="text-muted">
        <ds-truncatable-part [id]="dso.id" [minLines]="1">
          <ng-container *ngIf="firstMetadataValue('dc.publisher') || firstMetadataValue('dc.date.issued')">
            (<span *ngIf="firstMetadataValue('dc.publisher') as publisher" class="item-list-publisher" [innerHTML]="publisher"></span>
            <span *ngIf="firstMetadataValue('dc.publisher') && firstMetadataValue('dc.date.issued')">, </span>
          <span *ngIf="firstMetadataValue('dc.date.issued') as dateIssued" class="item-list-date" [innerHTML]="dateIssued"></span>)
          </ng-container>
          <span *ngIf="allMetadataValues(['dc.contributor.author', 'dc.creator', 'dc.contributor.*'], undefined).length > 0" class="item-list-authors">
            <span *ngFor="let author of allMetadataValues(['dc.contributor.author', 'dc.creator', 'dc.contributor.*'], true); let last=last;">
                <span [innerHTML]="author"><span [innerHTML]="author"></span></span>
                <span *ngIf="!last">; </span>
            </span>
          </span>
        </ds-truncatable-part>
      </span>
      <div *ngIf="firstMetadataValue('dc.description.abstract') as abstract" class="item-list-abstract">
        <ds-truncatable-part [id]="dso.id" [minLines]="3"><span
          [innerHTML]="abstract"></span>
        </ds-truncatable-part>
      </div>
    </ds-truncatable>
  </div>
</div>
